import React from "react";

import { BackGroundAnimation as StyledBackGroundAnimation } from "./style";

function BackGroundAnimation() {
  return <StyledBackGroundAnimation />;
}

export default BackGroundAnimation;
